// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"142":"1abf9bf1","741":"b07fd88a"}[chunkId] + ".css";
};